import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES     from '../../../services/services';

import Certificate from '../../../interfaces/Certificate';
import User from '../../../interfaces/User';

@Component({
  template: require('./certificate-application.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
  props:{
    status: String,
  }
})
export class CertificateApplication extends vue {
  data = {
    checked : false,
  };
  status;
  loadingStatus = true;
  middleName = '';
  leftitems = [];

  formUserData = {
    name: this.user.name,
    last_name: this.user.last_name,
    phone: this.user.phone,
    email: this.user.email,
    gender: this.user.gender,
    birthday: this.user.birthday,
    address: this.user.address,
    city: this.user.city,
    country: this.user.country,
    state: this.user.state,
    zip: this.user.zip,
    avatar: this.user.avatar
  };

  certificate = IocContainer.get < Certificate > (SERVICES.CERTIFICATE);
  
  // Preloader
  // get fullName(){
  //   return this.user.name  + ' ' + this.middleName;
  // }
  get loading() {
    return this.loadingUser && this.loadingLesson && this.courseLoaded && this.loadingStatus && this.userdata;
  }

  get loadingUser() {
    return this.$store.state.loadingUser;
  }

  get loadingLesson() {
    return this.userProgress.length > -1;
  }

  //  Data
  get courseData() {
    return this.$store.state.course;
  }

  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userProgress() {
    return this.$store.state.progress;
  }

  get userdata(){
    return this.formUserData = {
          name: this.user.name,
          last_name: this.user.last_name,
          phone: this.user.phone,
          email: this.user.email,
          gender: this.user.gender,
          birthday: this.user.birthday,
          address: this.user.address,
          city: this.user.city,
          country: this.user.country,
          state: this.user.state,
          zip: this.user.zip,
          avatar: this.user.avatar
        };
  }

  get user(){
    return this.$store.getters.user;
  }
  get courseLoaded(){
    if(this.courseData[this.courseData.length - 1]){
      if (this.lessonsData.find((lesson => {
        return lesson.unitId === this.courseData[this.courseData.length - 1].units[0].id;
      }))){
        return true;
      }
    }
    else{
      return false;
    }
  }
  get finalScore() {
    //need to calculate only for last unit
    let total = 0;
    let blocksUnits = this.userProgress.filter((lesson) => {
      return lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
    });
    
    blocksUnits.forEach(quiz => {
      total += quiz.resultPercentage;
    });
    return total / blocksUnits.length;
  }
  
  get lessonLastPassIndex() {
    if (this.userProgress.length > 0 && this.lessonsData.length > 0) {
      this.leftitems = [];
      this.lessonsData.forEach(element => {
              if (!this.userProgress.find((lesson => {
                if (lesson.type === 'App\\Models\\Quiz' && lesson.resultPercentage == undefined){
                  return false;
                }
                  return lesson.id == element.id && lesson.type == element.type;
              }
              ))){
                this.leftitems.push(this.lessonsData.indexOf(element));
              }
            });
    }
    return this.leftitems[0] - 1;
  }

  get finishedCourse() {
    if (this.userProgress.length > -1){
      if (this.finalScore > 65 && !this.lessonLastPassIndex){
        return this.userProgress.find((lesson) => {
          return lesson.id === this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id && lesson.type === this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].type && lesson.result && !lesson.hasOwnProperty('reset');
        });
      }
    else{
      return false;
      }
    }
  }


  requestCertificate() {
    if (this.middleName.length > 0){
      this.formUserData.name = this.formUserData.name + ' ' + this.middleName;
    }
    this.certificate.updateUser(this.formUserData).then(
      (response) => {
        this.loadingStatus = false;
        const { email } = this.$store.state.user;
        this.certificate.requestCertificate(email).then((response) => {
          location.reload();
        },
        (error) => {
          this.loadingStatus = true;
          console.log(error);
          },
        );
      },
    );
  }

  // updateProfile() {
  //   if (this.middleName.length > 0){
  //     this.formUserData.name = this.formUserData.name + ' ' + this.middleName;
  //   }
  //   this.certificate.updateUser(this.formUserData).then(
  //     (response) => {
  //       setTimeout(() => {
  //         location.reload();
  //         window.scroll(0, 0);
  //       }, 500);
  //     },
  //     (error) => {
  //       console.error(error.response.data.errors);
  //     },
  //   );
  // }

  get certStatus() {
    if(this.loadingUser){
      const { email } = this.$store.state.user;
      return (this.certificate.statusCertificate(email).then((response) => {
        return this.status = response.data.status;
      }));
    }
    else{
      return 'NOT_COMPLETED';
    }
  }
}